<template>
  <el-container class="chat-page">
    <!-- 账号列表 -->
    <transition
      name="account-list-slide"
      @before-enter="beforeAccountListEnter"
      @enter="accountListEnter"
      @after-enter="afterAccountListEnter"
      @before-leave="beforeAccountListLeave"
      @leave="accountListLeave"
      @after-leave="afterAccountListLeave"
    >
      <div
        v-if="!cicadeStore.accountListCollapsed"
        class="chat-list-box account-list-container"
        style="background: #f7f7f7"
      >
        <div class="chat-list-title" style="display: flex; align-items: center; justify-content: space-between">
          <div>
            <span>账号列表</span>
          </div>
          <div style="height: 20px; line-height: 20px">
            <el-dropdown
              v-if="
                cicadeStore.activeAccount?.channelName == 'telegram' ||
                cicadeStore.activeAccount?.channelName == 'facebook_api'
              "
              @command="(e) => onAccountCommand(e)"
            >
              <span class="el-dropdown-link"> <i class="el-icon-more-outline" style="cursor: pointer"></i> </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="accountSendMessage">批量打招呼</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
        <!-- <div class="chat-list-header">
                <el-input class="search-text" size="small" placeholder="搜索" v-model="accountSearchText">
                    <i class="el-icon-search el-input__icon" slot="prefix"> </i>
                </el-input>
            </div> -->
        <div
          class="chat-list-loading"
          v-if="accountLoading"
          v-loading="true"
          element-loading-text="账号加载中..."
          element-loading-spinner="el-icon-loading"
          element-loading-background="#F9F9F9"
          element-loading-size="24"
        ></div>
        <el-scrollbar class="chat-list-items" v-else>
          <div
            v-for="(account, index) in accountList"
            :key="index"
            class="chat-list-item account-list-item"
            :class="{ active2: account.id === cicadeStore.activeAccount?.id, 'is-unread-card': account.hasUnread }"
            @click="onActiveAccount(account.id)"
          >
            <div style="display: flex; align-items: center">
              <div style="position: relative">
                <el-avatar
                  v-if="account.avatar && cicadeStore.activeAccount?.channelName != 'customer'"
                  :size="30"
                  :src="`${baseUrl}${account.avatar}`"
                ></el-avatar>
                <el-avatar
                  v-else-if="cicadeStore.activeAccount?.channelName == 'customer' && account.headImageThumb"
                  :size="30"
                  :src="normalizeUrl(account.headImageThumb)"
                ></el-avatar>
                <el-avatar v-else :size="30">{{
                  account.account ? account.account.slice(0, 1).toUpperCase() : "-"
                }}</el-avatar>
                <span :class="account.status === 1 ? 'status-bq' : 'status-bq2'"></span>
                <!-- 负责人标记：能看到全部账号的当前登录用户即负责人，其名下账号 userId == 自己 id；头像右上角皇冠角标，悬停提示文字 -->
                <el-tooltip
                  v-if="isSupervisor && account.userId == currentUserInfo.id"
                  effect="dark"
                  content="负责人"
                  placement="top"
                >
                  <span class="account-role-crown">
                    <svg viewBox="0 0 24 24" width="11" height="11" fill="#fff" aria-hidden="true">
                      <path d="M3 7l4.5 4L12 4l4.5 7L21 7l-1.8 11H4.8L3 7zm2.6 13h12.8a1 1 0 010 2H5.6a1 1 0 010-2z" />
                    </svg>
                  </span>
                </el-tooltip>
              </div>
              <div style="display: flex; align-items: flex-start; margin-left: 10px; flex-direction: column">
                <span style="display: flex; align-items: center;">
                  <!-- 账号有新消息提示：名字加粗（配合卡片淡色高亮），纯前端实时点亮 -->
                  <span class="account-list-item__name" :class="{ 'is-unread': account.hasUnread }">{{ account.nickName || account.userName || account.account }}</span>
                </span>
                <span class="account-list-item__account">{{ account.account }}</span>
                <span style="display: flex">
                  <el-tag v-if="account.greetLimitStatus == 0" size="mini">受限</el-tag>
                  <el-tag v-if="account.limitStatus == 0" size="mini" type="warning">锁定</el-tag>
                  <el-tag v-if="account.countLimitStatus == 0" size="mini" type="info">限制</el-tag>
                </span>
              </div>
            </div>
            <div
              class="chat-list-item__more account-more-wrap"
              @click.stop
            >
              <!-- 账号有新消息提示：模式图标右上角红点，纯前端实时点亮 -->
              <span class="account-list-item__dot" v-if="account.hasUnread"></span>
              <el-dropdown @command="(e) => onCommand(e, account)">
                <span class="el-dropdown-link">
                  <img
                    v-if="account.chatMode == 0"
                    src="../assets/image/artificial.svg"
                    style="width: 18px; height: 18px"
                  />
                  <img v-if="account.chatMode == 1" src="../assets/image/robot.svg" style="width: 18px; height: 18px" />
                  <img v-if="account.chatMode == 2" src="../assets/image/ai.svg" style="width: 18px; height: 18px" />
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-if="account.channelName != 'customer'" command="setCount"
                    >设置打招呼次数</el-dropdown-item
                  >
                  <el-dropdown-item command="switchChatMode">切换聊天模式</el-dropdown-item>
                  <!-- <el-dropdown-item command="copyPhone">复制手机号</el-dropdown-item> -->
                  <el-dropdown-item v-if="account.greetLimitStatus === 0" command="greetLimit"
                    >解除受限</el-dropdown-item
                  >
                  <el-dropdown-item v-if="account.limitStatus === 0" command="unlock">解除锁定</el-dropdown-item>
                  <!-- <el-dropdown-item command="historyLog">刷新记录</el-dropdown-item> -->
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </el-scrollbar>
      </div>
    </transition>
    <!-- 会话列表 -->
    <ResizableAside class="chat-list-box" style="background: #fcfcfc" :width="285" :min-width="285" :max-width="400">
      <div class="chat-list-title" style="display: flex; align-items: center; justify-content: space-between">
        <div style="display: flex; align-items: center;">
          <img src="../assets/image/navbar.png" @click="$store.commit('toggleAccountListCollapsed')" :class="['el-icon-s-operation', 'icon-rotate', { rotated: cicadeStore.accountListCollapsed }]" style="width: 15px;height: 15px; margin-right: 10px; cursor: pointer" alt="">
          <span>会话列表</span>
        </div>
        <div style="height: 20px; line-height: 20px">
          <el-dropdown
            v-if="
              cicadeStore.activeAccount?.channelName == 'telegram' ||
              cicadeStore.activeAccount?.channelName == 'facebook_api'
            "
            @command="(e) => onAccountCommand(e)"
          >
            <span class="el-dropdown-link"> <i class="el-icon-more-outline" style="cursor: pointer"></i> </span>
            <el-dropdown-menu slot="dropdown">
              <!-- <el-dropdown-item v-if="cicadeStore.activeAccount.channelName == 'telegram'" command="phoneSendMessages">单账号打招呼(手机号)</el-dropdown-item> -->
              <!-- <el-dropdown-item v-if="cicadeStore.activeAccount.channelName == 'telegram'" command="accountSendMessages">单账号打招呼(用户名)</el-dropdown-item> -->
              <el-dropdown-item command="export">导出</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <div class="chat-list-header">
        <el-input class="search-text" size="small" placeholder="搜索" v-model="searchText">
          <i class="el-icon-search el-input__icon" slot="prefix"> </i>
        </el-input>
      </div>
      <div
        class="chat-list-loading"
        v-if="chatLoading"
        v-loading="true"
        element-loading-text="会话加载中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="#F9F9F9"
        element-loading-size="24"
      ></div>
      <el-scrollbar ref="chatListScrollbar" class="chat-list-items" v-else>
        <!-- 其他会话分组 -->
        <div
          class="chat-lists-item"
          :style="{ display: !searchText ? 'block' : 'none' }"
          v-for="(item, index) in groupListChatSorted"
          :key="index"
        >
          <div class="chat-list-tl" @contextmenu.prevent="onRightGroupt($event, item)" @click="toggle2(item)">
            <span>{{ item.groupName }}({{ item.chats.length || 0 }})</span>
            <!-- <i :class="['icon-arrow', item.isShow ? 'el-icon-caret-top' : 'el-icon-caret-bottom']"></i> -->
            <img v-if="item.isShow" class="icon-arrow" src="../assets/image/up.png" alt="">
            <img v-else class="icon-arrow" src="../assets/image/down.png" alt="">
          </div>
          <transition
            name="collapse"
            @before-enter="beforeEnter"
            @enter="enter"
            @after-enter="afterEnter"
            @before-leave="beforeLeave"
            @leave="leave"
            @after-leave="afterLeave"
          >
            <div class="list" v-if="item.isShow">
              <div
                v-for="(chat, index) in item.chats"
                :key="index"
                @contextmenu.prevent="onRightClick($event, chat)"
                class="breathing-box"
              >
                <div
                  :class="[
                    'chat-list-item',
                    {
                      active: chat.chatId === cicadeStore.activeChat?.chatId,
                      sticky: chat.isSticky,
                      'breathing-active': chat.marks?.includes('disconnect'),
                    },
                  ]"
                  @click="onActiveChat(chat)"
                >
                  <div style="display: flex; align-items: center">
                    <div
                      style="
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        height: 30px;
                        width: 30px;
                        line-height: 30px;
                        background-color: #c0c4cc;
                        border-radius: 50%;
                        position: relative;
                      "
                    >
                      <img
                        v-if="cicadeStore.activeAccount?.channelName == 'customer'"
                        :src="normalizeUrl(`${baseUrl}${chat.avatar}`)"
                        style="height: 100%; width: 100%"
                      />
                      <el-avatar v-else :size="30">{{
                        chat.title ? chat.title.slice(0, 1).toUpperCase() : "-"
                      }}</el-avatar>
                      <span :class="chat.online? 'status-bq' : 'status-bq2'" style="bottom: 0px;" ></span>
                    </div>
                    <span v-if="chat.userType == 'guest'" class="chat-list-item__name">{{ chat.chatId }}</span>
                    <span v-else class="chat-list-item__name">{{ chat.title }}</span>
                    <span v-if="chat.attentionPoint" class="chat-list-item__label"></span>
                  </div>
                  <div class="chat-list-item__num" v-if="chat.unreadCount > 0">
                    {{ chat.unreadCount > 99 ? "99+" : chat.unreadCount }}
                  </div>
                </div>
              </div>
            </div>
          </transition>
        </div>

        <!-- 全部会话分组 -->
        <div class="chat-lists-item" v-if="isShowAllChat">
          <div class="chat-list-tl" @contextmenu.prevent="onRightGroupt($event, 0)" @click="toggle">
            <span>所有用户会话({{ localChats.length || 0 }})</span>
            <!-- <i :class="['icon-arrow', isShow ? 'el-icon-caret-top' : 'el-icon-caret-bottom']"></i> -->
            <img v-if="isShow" class="icon-arrow" src="../assets/image/up.png" alt="">
            <img v-else class="icon-arrow" src="../assets/image/down.png" alt="">
          </div>
          <transition
            name="collapse"
            @before-enter="beforeEnter"
            @enter="enter"
            @after-enter="afterEnter"
            @before-leave="beforeLeave"
            @leave="leave"
            @after-leave="afterLeave"
          >
            <div class="list" v-if="isShow">
              <div
                v-for="(chat, index) in localChats"
                :key="index"
                @contextmenu.prevent="onRightClick($event, chat, 0)"
                class="breathing-box"
              >
                <div
                  :class="[
                    'chat-list-item',
                    {
                      active: chat.chatId === cicadeStore.activeChat?.chatId,
                      sticky: chat.isSticky,
                      'breathing-active': chat.marks?.includes('disconnect'),
                    },
                  ]"
                  @click="onActiveChat(chat)"
                >
                  <div style="display: flex; align-items: center">
                    <el-avatar v-if="chat.chatId >= 0 && !chat.avatar" :size="30">{{
                      chat.title ? chat.title.slice(0, 1).toUpperCase() : "-"
                    }}</el-avatar>
                    <div
                      v-else
                      style="
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        height: 30px;
                        width: 30px;
                        line-height: 30px;
                        background-color: #c0c4cc;
                        border-radius: 50%;
                        position: relative;
                      "
                    >
                      <img :src="normalizeUrl(`${baseUrl}${chat.avatar}`)" style="height: 100%; width: 100%" />
                      <span :class="chat.online? 'status-bq' : 'status-bq2'" style="bottom: 0px;" ></span>
                    </div>
                    <span v-if="chat.userType == 'guest'" class="chat-list-item__name">{{ chat.chatId }}</span>
                    <span v-else class="chat-list-item__name">{{ chat.title }}</span>
                    <span v-if="chat.attentionPoint" class="chat-list-item__label"></span>
                  </div>
                  <div class="chat-list-item__num" v-if="chat.unreadCount > 0">
                    {{ chat.unreadCount > 99 ? "99+" : chat.unreadCount }}
                  </div>
                </div>
              </div>
            </div>
          </transition>
        </div>

        <ul v-show="menu.visible" class="context-menu" :style="{ top: menu.y + 'px', left: menu.x + 'px' }">
          <li v-if="menu.target?.isSticky" @click="handleCloseTop">取消置顶</li>
          <li v-else @click="handleTop">置顶</li>
          <li v-if="menu.target?.groupType == 'progress'" @click="closeChat">结束对话</li>
          <li @click="handleGroup">移动至分组</li>
          <li v-if="menu.type == 'chat'" @click="handleLeave">移出此分组</li>
        </ul>

        <ul v-show="menu2.visible" class="context-menu" :style="{ top: menu2.y + 'px', left: menu2.x + 'px' }">
          <li @click="addCreateGroup">新建分组</li>
          <li v-if="menu2.type == 'group'" @click="delMoveGroup">删除分组</li>
          <li v-if="menu2.type == 'group'" @click="editGroup">编辑分组</li>
        </ul>
      </el-scrollbar>
    </ResizableAside>
    <!-- 聊天界面 -->
    <el-container class="chat-box">
      <chat-box v-if="cicadeStore.activeChat" :chat="cicadeStore.activeChat"></chat-box>
      <div class="chat-box__empty" v-else>选择任意对话以开始发送信息</div>
      <chat-user-profile
        v-if="cicadeStore.activeChat"
        @collapse="toggleCollapse"
        :isCollapsed="isCollapsed"
        :chat="cicadeStore.activeChat"
      ></chat-user-profile>
    </el-container>
    <!-- 分组弹窗 -->
    <el-dialog :visible.sync="dialogVisible" top="36vh" width="500px">
      <div slot="title">
        <div class="form-title">移动至</div>
      </div>
      <el-form ref="moveGroup" :rules="rules" :model="formGroup">
        <el-form-item label="目标分组" prop="moveGroupId" class="custom-label">
          <el-select v-model="formGroup.moveGroupId" size="small" style="width: 100%" placeholder="选择移动到分组">
            <el-option
              v-for="item in groupListChatSorted"
              :key="item.id"
              :label="item.groupName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="handleSumit">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="dialogEdit" top="36vh" width="500px">
      <div slot="title">
        <div class="form-title">编辑分组</div>
      </div>
      <el-form ref="formEditGroup" :rules="rulesEdit" :model="formEditGroup">
        <el-form-item label="分组名称" prop="editGroupName" class="custom-label">
          <el-input
            v-model="formEditGroup.editGroupName"
            size="small"
            style="width: 100%"
            clearable
            placeholder="输入组名称"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="dialogEdit = false">取 消</el-button>
        <el-button size="small" type="primary" @click="handleEdit">确 定</el-button>
      </div>
    </el-dialog>

    <batch-send :visible="showBatchSend" @close="showBatchSend = false"></batch-send>
    <exprot-data :visible="showExport" @close="showExport = false"></exprot-data>
    <chat-mode-setting
      :visible="showChatModeSetting"
      :account="account"
      @close="showChatModeSetting = false"
    ></chat-mode-setting>
    <bulk-send-messages :visible="showBulkSendMessages" @close="showBulkSendMessages = false"></bulk-send-messages>
    <phone-send-messages :visible="showPhoneSendMessages" @close="showPhoneSendMessages = false"></phone-send-messages>
    <account-phone-send-messages
      :visible="showAccountPhoneSendMessages"
      @close="showAccountPhoneSendMessages = false"
    ></account-phone-send-messages>
    <account-phone-send-messages-user
      :visible="showAccountUserSendMessages"
      @close="showAccountUserSendMessages = false"
    ></account-phone-send-messages-user>
  </el-container>
</template>

<script>
import ChatItem from "../components/chat/ChatItem.vue";
import ChatBox from "../components/chat/ChatBox.vue";
import ChatModeSetting from "../components/chatModeSetting/index.vue";
import ChatUserProfile from "../components/chat/ChatUserProfile.vue";
import BulkSendMessages from "../components/chat/BulkSendMessages.vue";
import PhoneSendMessages from "../components/chat/PhoneSendMessages.vue";
import AccountPhoneSendMessages from "../components/chat/AccountPhoneSendMessages.vue";
import AccountPhoneSendMessagesUser from "../components/chat/AccountUserSendMessages.vue";
import ResizableAside from "../components/chat/ResizableAside.vue";
import BatchSend from "../components/chat/BatchSend.vue";
import exprotData from "../components/chat/exprotData.vue";
import http from "@/api/httpRequest.js";
import { normalizeUrl } from "@/utils/index";

export default {
  name: "chat",
  components: {
    ChatItem,
    ChatBox,
    ChatModeSetting,
    ChatUserProfile,
    BulkSendMessages,
    PhoneSendMessages,
    AccountPhoneSendMessages,
    AccountPhoneSendMessagesUser,
    ResizableAside,
    BatchSend,
    exprotData,
  },
  data() {
    return {
      lastHiddenTime: 0,
      showExport: false,
      dialogVisible: false,
      dialogEdit: false,
      formGroup: {
        moveGroupId: null,
      },
      formEditGroup: {
        editGroupName: null,
      },
      isShow: true,
      baseUrl: process.env.VUE_APP_BASE_URL,
      isCollapsed: false,
      searchText: "",
      accountSearchText: "",
      messageContent: "",
      showChatModeSetting: false,
      group: {},
      groupMembers: [],
      account: {},
      showBulkSendMessages: false,
      showPhoneSendMessages: false,
      showAccountPhoneSendMessages: false,
      showAccountUserSendMessages: false,
      showBatchSend: false,
      menu: {
        type: "chat",
        visible: false,
        x: 0,
        y: 0,
        target: null,
      },
      menu2: {
        type: "group",
        visible: false,
        x: 0,
        y: 0,
        target: null,
      },
      rules: {
        moveGroupId: [
          {
            required: true,
            message: "请选择目标分组",
            trigger: "change",
          },
        ],
      },
      rulesEdit: {
        editGroupName: [
          {
            required: true,
            message: "请输入组名称",
            trigger: "change",
          },
        ],
      },
    };
  },
  mounted() {
    document.addEventListener("click", this.hideMenu);
    document.addEventListener("visibilitychange", this.handleVisibilityChange);
    // 如果初始状态不是加载中，则添加滚动监听
    if (!this.chatLoading) {
      this.addScrollListener();
    }
  },
  beforeDestroy() {
    document.removeEventListener("click", this.hideMenu);
    document.removeEventListener("visibilitychange", this.handleVisibilityChange);
    // 移除滚动事件监听
    this.removeScrollListener();
  },
  watch: {
    searchText() {
      this.isShow = true;
    },
    activeChannel() {
      this.searchText = "";
    },
    chatLoading(newVal) {
      // 当加载完成（chatLoading 变为 false）时，添加滚动监听
      if (!newVal) {
        this.$nextTick(() => {
          this.addScrollListener();
        });
      } else {
        // 加载中时移除监听
        this.removeScrollListener();
      }
    },
  },
  methods: {
    normalizeUrl,
    handleVisibilityChange() {
      if (document.visibilityState === 'hidden') {
        this.lastHiddenTime = Date.now();
      } else {
        const now = Date.now();
        if (now - this.lastHiddenTime < 1000) return;
        this.$store.dispatch("newLoadCicadeChat");
      }
    },
    // 添加滚动事件监听
    addScrollListener() {
      this.$nextTick(() => {
        const scrollbar = this.$refs.chatListScrollbar;
        if (scrollbar && scrollbar.$refs && scrollbar.$refs.wrap) {
          scrollbar.$refs.wrap.addEventListener("scroll", this.handleScroll);
        }
      });
    },
    // 移除滚动事件监听
    removeScrollListener() {
      const scrollbar = this.$refs.chatListScrollbar;
      if (scrollbar && scrollbar.$refs && scrollbar.$refs.wrap) {
        scrollbar.$refs.wrap.removeEventListener("scroll", this.handleScroll);
      }
    },
    handleScroll(e) {
      const target = e.target;
      const scrollBottom = target.scrollHeight - target.scrollTop - target.clientHeight;
      if (scrollBottom < 20) {
        // this.loadMore();
        console.log("触底了");
      }
    },
    addCreateGroup() {
      this.$prompt("请输入新建分组的名称", "新建", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /^[\u4e00-\u9fa5\w-]{1,20}$/,
        inputErrorMessage: "分组名格式不正确，仅限中英文、数字、下划线、短横线，最多20个字符",
      })
        .then(({ value }) => {
          this.$http
            .post("/client/createGroup", {
              channel: this.$store.state.cicadeStore.activeAccount.channelName,
              accountId: this.$store.state.cicadeStore.activeAccount.accountId,
              groupName: value,
            })
            .then((res) => {
              this.$store.dispatch("getGroupList");
            });
        })
        .catch(() => {
          // 取消
        });
    },
    delMoveGroup() {
      this.$confirm("确认删除此分组吗？, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(({ value }) => {
        this.$http
          .post("/client/deleteGroup", {
            id: this.menu2.target.id,
          })
          .then((res) => {
            this.$store.dispatch("getGroupList");
          });
      });
    },
    editGroup() {
      this.dialogEdit = true;
      this.formEditGroup.editGroupName = null;
      this.formEditGroup.editGroupName = this.menu2.target.groupName;
    },
    handleGroup() {
      this.dialogVisible = true;
      this.formGroup.moveGroupId = null;
    },
    handleLeave() {
      this.$confirm("确认移出此分组吗？, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(({ value }) => {
          this.$http
            .post("/client/deleteGroupChat", {
              chatId: this.menu.target.chatId,
              accountId: this.$store.state.cicadeStore.activeAccount.accountId,
            })
            .then((res) => {
              this.$store.dispatch("getGroupList");
              this.$message.success("移出成功");
            });
        })
        .catch(() => {
          // 取消
        });
    },
    handleSumit() {
      this.$refs.moveGroup.validate((valid) => {
        if (valid) {
          this.$confirm("确认移动到该分组吗？, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(() => {
            this.$http
              .post("/client/moveGroup", {
                chatId: this.menu.target.chatId,
                groupId: this.formGroup.moveGroupId,
                accountId: this.$store.state.cicadeStore.activeAccount.accountId,
              })
              .then(() => {
                this.$store.dispatch("getGroupList");
                this.$message.success("移动成功");
                this.dialogVisible = false;
              });
          });
        }
      });
    },
    handleEdit() {
      this.$refs.formEditGroup.validate((valid) => {
        if (valid) {
          this.$confirm("确认修改该分组的名称吗？, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(() => {
            http({
              url: "/client/updateGroupName",
              method: "POST",
              data: {
                id: this.menu2.target.id,
                groupName: this.formEditGroup.editGroupName,
              },
            }).then(() => {
              this.$store.dispatch("getGroupList");
              this.$message.success("编辑成功");
              this.dialogEdit = false;
            });
          });
        }
      });
    },
    onRightGroupt(event, item) {
      this.menu2 = {
        type: "group",
        visible: false,
        x: 0,
        y: 0,
        target: null,
      };
      this.menu2.visible = true;
      // 使用视口坐标，避免被右侧聊天框遮挡
      this.menu2.x = event.clientX + window.scrollX;
      this.menu2.y = event.clientY + window.scrollY;
      this.menu2.target = item;
      if (item === 0) {
        this.menu2.type = "main";
      }
    },
    toggle() {
      this.isShow = !this.isShow;
    },
    toggle2(item) {
      this.isShow = false;
      this.$store.commit("toggleGroup", item);
    },
    handleTop() {
      console.log("置顶", this.menu.target);
      this.$http
        .post("/client/addSticky", {
          channel: this.$store.state.cicadeStore.activeAccount.channelName,
          accountId: this.$store.state.cicadeStore.activeAccount.accountId,
          chatId: this.menu.target.chatId,
        })
        .then((res) => {
          this.$store.dispatch("loadCicadeChat");
          console.log(res);
        });
    },
    handleCloseTop() {
      console.log("取消置顶");
      this.$http
        .post("/client/removeSticky", {
          channel: this.$store.state.cicadeStore.activeAccount.channelName,
          accountId: this.$store.state.cicadeStore.activeAccount.accountId,
          chatId: this.menu.target.chatId,
        })
        .then((res) => {
          this.$store.dispatch("loadCicadeChat");
          console.log(res);
        });
    },
    closeChat() {
      this.$confirm("确认结束此对话吗？, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$http
          .post("/customer/finishChat", {
            accountId: this.$store.state.cicadeStore.activeAccount.accountId,
            chatId: this.menu.target.chatId,
          })
          .then((res) => {
            this.$store.dispatch("getGroupList");
          });
      });
    },
    onRightClick(event, item, num) {
      this.menu = {
        type: "chat",
        visible: false,
        x: 0,
        y: 0,
        target: null,
      };
      this.menu.visible = true;
      // 使用视口坐标，避免被右侧聊天框遮挡
      this.menu.x = event.clientX + window.scrollX;
      this.menu.y = event.clientY + window.scrollY;
      this.menu.target = item;
      if (num === 0) {
        this.menu.type = "main";
      }
    },
    hideMenu() {
      this.menu.visible = false;
      this.menu2.visible = false;
    },
    toggleCollapse(val) {
      this.isCollapsed = val;
    },
    onAccountCommand(command) {
      console.log(command);
      if (command === "phoneSendMessages") {
        this.showPhoneSendMessages = true;
      } else if (command === "bulkSendMessages") {
        this.showBulkSendMessages = true;
      } else if (command === "export") {
        this.showExport = true;
      } else if (command === "accountSendMessage") {
        // this.showAccountPhoneSendMessages = true;
        this.showBatchSend = true;
      } else if (command === "accountUserSendMessage") {
        this.showAccountUserSendMessages = true;
      }
    },
    onCommand(command, account) {
      if (command === "switchChatMode") {
        this.account = account;
        this.showChatModeSetting = true;
      } else if (command === "copyPhone") {
        this.copyText(account.account);
      } else if (command === "unlock") {
        this.hanldeUnlock(account, "limitStatus");
      } else if (command === "greetLimit") {
        this.hanldeUnlock(account, "greetLimitStatus");
      } else if (command === "historyLog") {
        this.hanldeLog(account);
      } else if (command == "setCount") {
        this.$prompt("设置打招呼最多次数为(默认为20)", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          inputPattern: /^(0|[1-9]\d*)$/,
          inputErrorMessage: "输入错误",
          inputValue: account.countLimit,
        })
          .then(({ value }) => {
            http({
              url: "/client/setGreetCount",
              method: "POST",
              params: {
                accountId: account.accountId,
                count: value,
              },
            }).then((res) => {
              this.$store.dispatch("loadAccount");
              this.$message({
                type: "success",
                message: "设置成功",
              });
            });
          })
          .catch(() => {});
      }
    },
    hanldeLog(item) {
      this.$confirm("此操作将刷新该账号下的会话记录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http.post("/client/refHistory?accountId=" + item.accountId).then((res) => {
            this.$message.success("刷新成功");
          });
        })
        .catch(() => {
          // 取消
        });
    },
    hanldeUnlock(item, type) {
      this.$confirm(`此操作将解除该账号的${type == "limitStatus" ? "锁定" : "受限"}状态, 是否继续?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http.post("/client/removeLimit?id=" + item.accountId + "&type=" + type).then((res) => {
            this.$message.success("解除成功");
            this.$store.dispatch("loadAccount");
          });
        })
        .catch(() => {
          // 取消
        });
    },
    async copyText(text) {
      try {
        await navigator.clipboard.writeText(text);
        this.$message.success("复制成功");
      } catch (err) {
        this.$message.error("复制失败");
      }
    },
    onActiveItem(index) {
      this.$store.commit("activeChat", index);
    },
    onDelItem(index) {
      this.$store.commit("removeChat", index);
    },
    onTop(chatIdx) {
      this.$store.commit("moveTop", chatIdx);
    },
    onActiveAccount(accountId) {
      if (accountId == this.$store.state.cicadeStore.activeAccount.id) return;
      this.$store.commit("activeAccount", {
        context: this.$store,
        accountId: accountId,
      });
    },
    onActiveChat(chat) {
      // if (chat.marks.length > 0) {
      //   http({
      //     url: "/client/cancelMark",
      //     method: "POST",
      //     params: {
      //       chatId: chat.chatId,
      //       channelName: this.$store.state.cicadeStore.activeAccount.channelName,
      //       accountId: this.$store.state.cicadeStore.activeAccount.accountId,
      //       markType: "disconnect",
      //     },
      //   }).then((res) => {
      //     this.$store.commit("clearChatMarks", chat.chatId);
      //   });
      // }
      sessionStorage.setItem("activeChat", chat.chatId);
      this.$store.commit("setActiveChat", {
        context: this.$store,
        chatId: chat.chatId,
      });
    },
    beforeEnter(el) {
      el.style.height = "0";
      el.style.opacity = "0";
    },
    enter(el) {
      el.style.transition = "height 0.3s ease, opacity 0.3s ease";
      el.style.height = el.scrollHeight + "px";
      el.style.opacity = "1";
    },
    afterEnter(el) {
      el.style.height = "auto";
      el.style.transition = "";
    },
    beforeLeave(el) {
      el.style.height = el.scrollHeight + "px";
      el.style.opacity = "1";
    },
    leave(el) {
      el.style.transition = "height 0.3s ease, opacity 0.3s ease";
      void el.offsetHeight;
      el.style.height = "0";
      el.style.opacity = "0";
    },
    afterLeave(el) {
      el.style.transition = "";
    },
    beforeAccountListEnter(el) {
      el.style.width = "0";
      el.style.opacity = "0";
      el.style.overflow = "hidden";
    },
    accountListEnter(el, done) {
      // 使用更流畅的缓动函数，宽度先快后慢，透明度稍延迟
      el.style.transition = "width 0.3s cubic-bezier(0.16, 1, 0.3, 1), opacity 0.35s ease 0.05s";
      void el.offsetHeight; // 触发重排，开始动画
      el.style.width = "230px";
      el.style.opacity = "1";
      setTimeout(() => {
        done();
      }, 400);
    },
    afterAccountListEnter(el) {
      el.style.transition = "";
      el.style.width = "";
    },
    beforeAccountListLeave(el) {
      // 立即设置宽度为0，避免预留位置
      el.style.width = "0";
      el.style.overflow = "hidden";
    },
    accountListLeave(el, done) {
      el.style.transition = "width 0.3s cubic-bezier(0.55, 0.06, 0.68, 0.19), opacity 0.2s ease";
      void el.offsetHeight; // 触发重排，开始动画
      el.style.opacity = "0";
      setTimeout(() => {
        done();
      }, 400);
    },
    afterAccountListLeave(el) {
      el.style.transition = "";
      el.style.width = "";
    },
  },
  computed: {
    // 当前登录用户信息（用于标记负责人：能看到全部账号的就是负责人，其名下账号 userId == 自己 id）
    currentUserInfo() {
      return this.$store.state.userStore.userInfo || {};
    },
    isSupervisor() {
      return (this.$store.state.userStore.roles || []).includes("customer_admin");
    },
    accountList() {
      const accounts = this.$store.state.cicadeStore.accounts || [];
      const searchText = this.accountSearchText?.trim().toLowerCase() || "";
      const filtered = accounts.filter((account) => {
        const accountField = account.account?.toLowerCase() || "";
        const accountNameField = (account.nickName || account.userName)?.toLowerCase() || "";
        return accountField.includes(searchText) || accountNameField.includes(searchText);
      });
      // 负责人账号置顶：当前登录用户为负责人时，其名下账号(userId == 自己 id)排在最上面，保持原有相对顺序
      const isOwnerAccount = (account) => this.isSupervisor && account.userId == this.currentUserInfo.id;
      const sorted = [...filtered].sort((a, b) => (isOwnerAccount(b) ? 1 : 0) - (isOwnerAccount(a) ? 1 : 0));
      // 过滤
      if (!this.pinnedAccountId) return sorted;
      const pinnedIndex = sorted.findIndex((acc) => acc.id === this.pinnedAccountId);
      if (pinnedIndex === -1) return sorted;
      const [pinnedItem] = sorted.splice(pinnedIndex, 1);
      return [pinnedItem, ...sorted];
    },
    chatStore() {
      return this.$store.state.chatStore;
    },
    cicadeStore() {
      return this.$store.state.cicadeStore;
    },
    activeChat() {
      return this.$store.state.activeChat;
    },
    activeChannel() {
      return this.$store.state.cicadeStore.activeChannel;
    },
    accountLoading() {
      return this.$store.state.cicadeStore.accountLoading;
    },
    chatLoading() {
      return this.$store.state.cicadeStore.chatLoading;
    },
    loading() {
      return this.chatStore.loadingGroupMsg || this.chatStore.loadingPrivateMsg;
    },
    localChats() {
      const chats = this.$store.state.cicadeStore.chats || [];
      const keyword = (this.searchText || "").toLowerCase();

      const sortedChats = [...chats]
        .sort((a, b) => {
          // 1. isSticky 排序（true 的在前）
          const aSticky = a.isSticky ? 1 : 0;
          const bSticky = b.isSticky ? 1 : 0;
          if (aSticky !== bSticky) {
            return bSticky - aSticky;
          }

          // 2. stickyTime 排序（新的在前）
          if (a.isSticky && b.isSticky) {
            const aTime = a.stickyTime || 0;
            const bTime = b.stickyTime || 0;
            if (aTime !== bTime) {
              return bTime - aTime;
            }
          }

          // 3. portrait 排序（有标记的在前）
          const aHasPortrait = a.portraitValues != null ? 1 : 0;
          const bHasPortrait = b.portraitValues != null ? 1 : 0;
          if (aHasPortrait !== bHasPortrait) {
            return bHasPortrait - aHasPortrait;
          }

          // 4. 时间戳排序（新在前）
          return (b.timestamp || 0) - (a.timestamp || 0);
        })
        .filter(
          (chat) =>
            (chat.title && chat.title.toLowerCase().includes(keyword)) ||
            (chat.userType == "guest" && chat.chatId.toLowerCase().includes(keyword))
        );

      return sortedChats;
    },
    groupListChatSorted() {
      const groups = this.$store.state.cicadeStore.groupList || [];

      const sortChats = (chats) => {
        return [...(chats || [])].sort((a, b) => {
          // 1. 置顶
          if (!!b.isSticky - !!a.isSticky !== 0) {
            return !!b.isSticky - !!a.isSticky;
          }
          // 2. 置顶时间
          if (a.isSticky && b.isSticky) {
            const aTime = Number(a.stickyTime) || 0;
            const bTime = Number(b.stickyTime) || 0;
            if (bTime !== aTime) return bTime - aTime;
          }
          // 3. 有 portraitValues 的在前
          if (!!b.portraitValues - !!a.portraitValues !== 0) {
            return !!b.portraitValues - !!a.portraitValues;
          }
          // 4. 时间戳
          const aTimestamp = Number(a.timestamp) || 0;
          const bTimestamp = Number(b.timestamp) || 0;
          return bTimestamp - aTimestamp;
        });
      };

      return groups.map(group => ({
        ...group,
        chats: sortChats(group.chats)
      }));
    },
    isShowAllChat() {
      const isCustomer = this.cicadeStore.activeAccount?.channelName === "customer";
      const hasAccount = this.accountList.length > 0;
      const hasSearch = this.searchText !== "";
      return !isCustomer || (hasAccount && hasSearch);
    },
  },
};
</script>

<style lang="scss">
.chat-page {
  .chat-list-box {
    display: flex;
    flex-direction: column;
    border-right: 1px solid #f3f3f3;
    // background: var(--im-background);
    user-select: none;

    .chat-list-title {
      width: 100%;
      height: 50px;
      line-height: 50px;
      padding: 0 15px;
      font-size: 18px;
      font-weight: bold;
      text-align: center;
      box-sizing: border-box;
      border-bottom: 1px solid #ebeef5;
      // background-color: rgb(153, 153, 153, 0.3);
    }

    .chat-list-header {
      height: 50px;
      display: flex;
      align-items: center;
      padding: 0 8px;
    }

    .chat-list-loading {
      height: 120px;
      background-color: #eee;

      .el-icon-loading {
        font-size: 24px;
        color: var(--im-text-color-light);
      }

      .el-loading-text {
        color: var(--im-text-color-light);
      }

      .chat-loading-box {
        height: 100%;
      }
    }

    .chat-list-items {
      position: relative;
      flex: 1;
      display: flex;
      flex-direction: column;
      height: calc(100vh - 104px);

      .chat-list-item {
        position: relative;
        display: flex;
        align-items: center;
        padding: 15px;
        box-sizing: border-box;
        justify-content: space-between;
        // cursor: pointer;
        border-bottom: 1px solid #f3f3f3;

        &__name {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          width: 180px;
          text-align: left;
          font-size: 14px;
          padding-left: 8px;
        }

        &__label::after {
          position: absolute;
          top: 50%;
          right: 15%;
          transform: translate(-50%, -50%);
          content: "";
          display: inline-block;
          width: 10px;
          height: 10px;
          background-color: #f72f2f;
          border-radius: 50%;
          margin-right: 8px;
        }

        &__num {
          background-color: rgb(245, 108, 108);
          color: rgb(255, 255, 255);
          display: inline-block;
          font-size: 12px;
          height: 18px;
          line-height: 18px;
          text-align: center;
          border-radius: 10px;
          padding: 0px 6px;
          border: 1px solid #fff;
          white-space: nowrap;
        }

        &:hover {
          background-color: #fff;
        }

        &.active {
          background-color: #f2f4ff !important;
        }
      }

      .chat-list-item.sticky {
        background-color: #f2f2f2;
      }

      .chat-list-item.sticky.breathing-active {
        animation: bg-breathing 2.5s ease-in-out infinite !important;
      }

      .chat-list-item-left {
        margin-right: 10px;
      }
    }

    .account-list-item {
      display: flex;
      align-items: center;
      padding: 10px;
      margin: 10px 10px 0;
      border-radius: 5px;
      box-sizing: border-box;
      border-bottom: 1px solid #f2f2f2;
      cursor: pointer;

      &__name {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 120px;
        text-align: left;
        font-size: 14px;

        &.is-unread {
          font-weight: 600;
          color: #1f2329;
        }
      }

      &__account {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 120px;
        text-align: left;
        font-size: 12px;
        color: #666;
        padding: 2px 0;
      }

      // 有新消息：卡片整体淡色高亮（纯前端实时点亮，读完自动恢复）
      &.is-unread-card {
        background-color: #fff5f5;
      }

      // 模式图标右上角红点
      .account-more-wrap {
        position: relative;
      }

      &__dot {
        position: absolute;
        top: -3px;
        right: -3px;
        z-index: 2;
        width: 9px;
        height: 9px;
        background-color: rgb(245, 108, 108);
        border-radius: 50%;
        border: 1px solid #fff;
        box-sizing: border-box;
      }

      &:hover {
        background-color: #f3f3f3;
      }

      &.active {
        background-color: #f3f3f3;
      }

      &.active2 {
        background-color: #fff;
      }

      &.disabled {
        color: #ccc;
        cursor: not-allowed;
      }
    }
  }
}

.context-menu {
  position: fixed;
  background: white;
  border: 1px solid #ccc;
  list-style: none;
  padding: 0;
  margin: 0;
  z-index: 999;
  width: 100px;
  max-height: 240px;
  overflow-y: auto;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.context-menu li {
  font-size: 12px;
  padding: 8px 10px;
  cursor: pointer;
}

.context-menu li:hover {
  background-color: #eee;
}

.icon-rotate {
  transition: transform 0.2s ease;
}

.icon-rotate.rotated {
  transform: rotate(90deg);
}

.status-bq {
  position: absolute;
  bottom: 5px;
  right: -2px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  border: 2px solid #fff;
  display: inline-block;
  background: #00c853;
}
.status-bq2 {
  position: absolute;
  bottom: 5px;
  right: -2px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  border: 2px solid #fff;
  display: inline-block;
  background: #c3c3c3;
}

.breathing-box {
  transition: box-shadow 0.3s ease;
}

.breathing-active {
  animation: bg-breathing 5s ease-in-out infinite;
}

.chat-box__empty {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  color: #999999;
  cursor: default;
}

/* 背景颜色呼吸灯动画：亮→暗→亮 */
@keyframes bg-breathing {
  0% {
    background-color: #fff;
  }
  50% {
    background-color: #f03d33;
  }
  100% {
    background-color: #fff;
  }
}

.chat-list-item.sticky.breathing-active {
  animation: bg-breathing 2.5s ease-in-out infinite !important;
}
</style>
<style scoped>
.form-title {
  font-size: 18px;
  color: #303133;
  font-weight: 400;
  display: flex;
  align-items: flex-start;
}
.custom-label .el-form-item__label {
  font-size: 14px;
  color: #000;
}
.chat-lists-item {
  margin-bottom: 5px;
}
.chat-list-tl {
  font-size: 13px;
  padding: 8px 20px 8px 15px;
  font-weight: bold;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #f2f2f2;
  /* box-shadow: 2px 2px 5px rgba(0,0,0,0.1); */
}
.chat-list-tl:hover {
  background: #fcfcfc;
}
.icon-arrow {
  width: 10px;
  height: 10px;
  transition: all 0.3s ease;
  /* font-size: 16px; */
  /* display: inline-block; */
}

.collapse-enter-active,
.collapse-leave-active {
  overflow: hidden;
}
.collapse-enter,
.collapse-leave-to {
  opacity: 0;
}
.collapse-enter-to,
.collapse-leave {
  opacity: 1;
}

/* 账号列表滑动过渡动画 - 使用 JavaScript hooks 控制，不需要 CSS 过渡类 */
.account-list-container {
  width: 230px;
  flex-shrink: 0;
  min-width: 0;
  overflow: hidden;
}

/* 负责人皇冠徽章：头像右下角金色圆形徽章 + 白色矢量皇冠，矢量锐利、跨平台一致 */
.account-role-crown {
  position: absolute;
  right: -4px;
  top: -4px;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: linear-gradient(135deg, #ffc24d 0%, #f5a623 100%);
  border: 1.5px solid #fff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  cursor: default;
}
.account-role-crown svg {
  display: block;
}
</style>
